@if (marketsPassedIn && marketsPassedIn.length) {
  <div class="attraction-carousel-wrapper">
    <owl-carousel-o [options]="customOptions" class="attraction-carousel">
      @for (_market of marketsPassedIn; track _market; let i = $index) {
        <ng-template carouselSlide>
          <div class="carousel-image-wrapper">
            @if (_market?.photos[0]?.photo) {
              <img [src]="_market.photos[0].photo" (dblclick)="goToHotMarketDetails(_market)">
            }
            @if (!_market?.photos[0]?.photo) {
              <img [src]="'/assets/images/no_image_available.jpeg'" (dblclick)="goToHotMarketDetails(_market)">
            }
            @if (_market?.photos[0]?.html_attributions[0]) {
              <figcaption class="image-cite">
                Photo: <span [innerHTML]="_market.photos[0].html_attributions[0] | safeHtml" [matTooltip]="_market?.photos[0]?.citeToolTip" [matTooltipPosition]="'above'"></span>
              </figcaption>
            }
          </div>
          <div class="carousel-image-data">
            @if (_market?.name) {
              <div class="attraction-title" [matTooltip]="_market.name"
                matTooltipClass="market-name" [matTooltipPosition]="'above'"
                (click)="goToHotMarketDetails(_market)">
                {{ _market.name }}
              </div>
            }
          </div>
        </ng-template>
      }
    </owl-carousel-o>
  </div>
}